import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Addresses_ds_ownersaccounts_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { ownerId: number, typeIds: number[], accountTypeId: number, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.ownerId)) {
      $missingRequiredInParams.push('\'ownerId\'');
    }
    if (isNil($inParams.typeIds)) {
      $missingRequiredInParams.push('\'typeIds\'');
    }
    if (isNil($inParams.accountTypeId)) {
      $missingRequiredInParams.push('\'accountTypeId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { ownerId: number, typeIds: number[], accountTypeId: number, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.ownerId)) {
      $missingRequiredInParams.push('\'ownerId\'');
    }
    if (isNil($inParams.typeIds)) {
      $missingRequiredInParams.push('\'typeIds\'');
    }
    if (isNil($inParams.accountTypeId)) {
      $missingRequiredInParams.push('\'accountTypeId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { ownerId: number, typeIds: number[], accountTypeId: number, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.ownerId)) {
      $missingRequiredInParams.push('\'ownerId\'');
    }
    if (isNil($inParams.typeIds)) {
      $missingRequiredInParams.push('\'typeIds\'');
    }
    if (isNil($inParams.accountTypeId)) {
      $missingRequiredInParams.push('\'accountTypeId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      ownerId: number, typeIds: number[], accountTypeId: number, fullTextSearch?: string    }) {
        if(isNil($inParams.ownerId)) {
          return true; 
        }
        if(isNil($inParams.typeIds)) {
          return true; 
        }
        if(isNil($inParams.accountTypeId)) {
          return true; 
        }
      return false;
    }
}
